"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsData = void 0;
const util_1 = require("../util/util");
class AnalyticsData {
    constructor() {
        this._map = new Map();
        this.push("source", "embed");
        this.push("pageTitle", document.title);
        this.push("pageURL", location.href);
        this.push("referrer", document.referrer);
        this.push("user_id", AnalyticsData._GetUserID());
    }
    push(key, value) {
        this._map.set(key, value);
    }
    get(key) {
        return this._map.get(key);
    }
    get data() {
        return Object.fromEntries(this._map);
    }
    get map() {
        return this._map;
    }
    static _GetUserID() {
        const key = "plattar_user_id";
        let userID = null;
        try {
            userID = localStorage.getItem(key);
        }
        catch (err) {
            userID = util_1.Util.generateUUID();
            // try storing if just generated
            try {
                localStorage.setItem(key, userID);
            }
            catch (_err) { /* silent */ }
        }
        if (!userID) {
            userID = util_1.Util.generateUUID();
            // try storing if just generated
            try {
                localStorage.setItem(key, userID);
            }
            catch (_err) { /*silent */ }
        }
        return userID;
    }
}
exports.AnalyticsData = AnalyticsData;
